import DataTable from "@mostrans/web-components/components/advanced/DataTable";
import { DATE_FORMAT } from "@mostrans/web-components/constants/dateFormat";
import { Icon, IconButton } from "@mui/material";
import moment from "moment";
import React, { useEffect } from "react";
import { useGetEmployeeDemographyAdminWithFilter } from "../../../../GQL/Demography/hooks/useGetEmployeeDemographyAdminWithFilter";
import Badge from "../../../../components/General/Badge";
import Case from "../../../../components/General/Case";
import LoadingFallback from "../../../../components/General/LoadingFallback";
import { FlexColumn } from "../../../../components/Layout/Flex";
import { useModals } from "../../../../shared/hooks/useModals";

export default function ListingDemography() {
  const { filteredDemography, dataDemography, refetchOnChange } =
    useGetEmployeeDemographyAdminWithFilter();
  const { showModal } = useModals();

  useEffect(() => {
    refetchOnChange();
  }, [refetchOnChange]);

  return (
    <div className="mt-1">
      <Case
        when={!dataDemography.loading}
        then={
          <DataTable
            hasPagination
            data={filteredDemography}
            getRowKey={(data) => data.id}
            columns={[
              {
                selector: "id",
                getCellKey: (data) => "id" + data.id,
                renderCell: (data) => (
                  <IconButton onClick={() => showModal("editCategory", data)}>
                    <Icon>edit</Icon>
                  </IconButton>
                ),
              },
              {
                header: "Demography Name",
                selector: "demo_name",
                // headerCellStyle: {
                //   width: "400px",
                // },
                getCellKey: (data) => "demo_name" + data.id,
                renderCell: (data) => data?.demography_name,
              },
              {
                header: "Demography Value",
                selector: "demo_value",
                // headerCellStyle: {
                //   width: "400px",
                // },
                getCellKey: (data) => "value" + data.id,
                renderCell: (data) => (
                  <>
                    {data?.value}
                    <span>
                      {data?.value_type === "Persen" ||
                      data?.value_type === "Percent"
                        ? "%"
                        : ""}
                    </span>
                  </>
                ),
              },
              {
                header: "Created Date / Status",
                selector: "create_date",
                getCellKey: (data) => "create_date" + data.id,
                renderCell: (data) => (
                  <FlexColumn>
                    <div> 
                      <Badge
                        variant={data?.deleted_date ? "danger" : "primary"}
                      >
                        {data?.deleted_date ? "Inactive" : "Active"}
                      </Badge>
                    </div>
                    <b className="text-primary-main">
                      {moment(data?.create_date, DATE_FORMAT.unix).format(
                        "DD MMMM YYYY HH:mm"
                      )}
                    </b>
                  </FlexColumn>
                ),
              },
            ]}
          />
        }
        else={<LoadingFallback />}
      />
    </div>
  );
}
